import { createContext } from "react";

export type CurrentUser = {
  basicInfo: {
    name: string;
    points: number;
    bindAccount: string;
    bindAddress: string;
  };
  checkInModule: {
    checkedDay: number;
    checkInState: boolean;
  };
  pointShopModule: {
    exchangeRecord: Record<string, number>;
  };
  miniGameModule: {};
};

export type GlobalContext = {
  currentUser: CurrentUser | null;
  setCurrentUser: React.Dispatch<React.SetStateAction<CurrentUser | null>>;
  needLogin: boolean;
  setNeedLogin: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GlobalContext = createContext<GlobalContext>();
GlobalContext.displayName = "GlobalContext";
